export default [
  {
    name: 'ORG_ID',
    value: '00000000-0000-0000-0000-000000000000'
  }
]